'use strict'

const adapterApiCreator = require('./adapterApi')
const {
  createComponentAdapterContexts,
  createDetailsRepeatersAdapterContexts
} = require('./createComponentAdapter')

const {
  assertValidityCmd,
  bindToComponentCmd,
  currentRecordModifiedCmd,
  executor,
  notifyIndexChangeCmd,
  notifyRecordSetLoadedCmd,
  updateCurrentViewCmd
} = require('./executor')

const initAdapters = require('./initAdapters')

module.exports = {
  adapterApiCreator,
  assertValidityCmd,
  bindToComponentCmd,
  createComponentAdapterContexts,
  createDetailsRepeatersAdapterContexts,
  currentRecordModifiedCmd,
  executor,
  initAdapters,
  notifyIndexChangeCmd,
  notifyRecordSetLoadedCmd,
  updateCurrentViewCmd
}



// WEBPACK FOOTER //
// ./adapters/index.js